import colors from '../../colors';

const DayScreenTheme = {
  BarcodeScan: {
    BackgroundColor: colors.gray.lightGray,
    FontsColor: colors.gray.primary,
    HeadingFontsColor: colors.black,
  },
  ErrorMessage:{
    FontsColor: colors.gray.primary,
  },
};

export default DayScreenTheme;


